function ready() {
	let $modalAlert = $('#modal-alert');
	if (!$modalAlert.length) {
		return false;
	}

	// modal alert
	let localStorageModalAlert = localStorage.getItem('modal-alert'),
		localStorageModalAlertTime = localStorage.getItem('modal-alert-time');

	if (!localStorageModalAlert || !localStorageModalAlertTime) {
		showAlert();
		showAlertModal($modalAlert);
	} else if (localStorageModalAlertTime) {
		let storageTime = new Date(localStorageModalAlertTime);

		let nextTime = new Date(localStorageModalAlertTime);
		nextTime.setHours(nextTime.getHours() + 4);

		if (storageTime.getTime() > nextTime.getTime()) {
			showAlert();
			showAlertModal($modalAlert);
		} else {
			showAlert();
		}
	}

	function showAlert() {
		$(document).find('#alert-tech-works').removeClass('d-none')
	}

	function showAlertModal($modal) {
		$modal.modal('show');

		$modal.on('hidden.bs.modal', function (event) {
			localStorage.setItem('modal-alert', 1);
			localStorage.setItem('modal-alert-time', new Date());
		});
	}
}

document.addEventListener('DOMContentLoaded', ready);
typeof onTurboRender !== 'undefined' && onTurboRender(ready);
